import { EResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setDominantRegionId = actionGenerator<EResultsActionType.SetDominantRegionId, number | null>(
  EResultsActionType.SetDominantRegionId,
);
